import React, { useState } from "react";
import { AddToolTip } from "../../../components";
import VerifyMapExcelOutputContainer from "./../VerifyMapOutputContainer/VerifyMapExcelOutputContainer";
import { get, isNull, startsWith } from "lodash-es";
import {
  jsonToStringConverter,
  passthroughStringToFunctionConverter,
  stringToFunctionConverter,
} from "./../../../utils/constants/mapper";

const PreviewSection = ({
  isNewField = false,
  fields,
  values,
  isFixedWidth,
  fieldName,
  mapType,
  sections,
}) => {
  const [sourceData] = sections;
  const [show, setShow] = useState(false);
  return (
    <>
      {!show ? (
        <div className="d-flex preview-container align-items-baseline">
          <span className={`ft-14 fw-500 ${!isFixedWidth ? "mr-5" : "mr-2"}`}>
            Preview<span class="active-dot">●</span>
          </span>
          {!isFixedWidth ? (
            <div className="d-flex preview-card justify-content-between">
              <span className="ft-12 w-50">
                {mapType == 3 ? (
                  isNewField ? (
                    <AddToolTip
                      name={passthroughStringToFunctionConverter(
                        jsonToStringConverter(values?.headerData),
                        sourceData?.fields,
                        0
                      )?.toString()}
                    />
                  ) : (
                    <AddToolTip name={values.headerData.value} />
                  )
                ) : (
                  <AddToolTip
                    name={stringToFunctionConverter(
                      jsonToStringConverter(values?.headerData),
                      1
                    )?.toString()}
                  />
                )}
              </span>
              <span className="d-flex ft-12" style={{ width: "45%" }}>
                <span className="grey-text mr-1">Value:</span>
                <AddToolTip
                  className={"ml-1"}
                  style={{ marginTop: "3px" }}
                  name={
                    mapType == 3
                      ? passthroughStringToFunctionConverter(
                          jsonToStringConverter(values?.valueData),
                          sourceData?.fields,
                          1
                        )?.toString()
                      : stringToFunctionConverter(
                          jsonToStringConverter(values?.valueData),
                          0
                        )?.toString()
                  }
                />
                {/* <AddToolTip
                  name={stringToFunctionConverter(
                    jsonToStringConverter(values?.valueData),
                    0
                  )?.toString() == null ? "" : stringToFunctionConverter(
                    jsonToStringConverter(values?.valueData),
                    0
                  )?.toString()}
                /> */}
              </span>
            </div>
          ) : (
            <div
              className="d-flex preview-card justify-content-between"
              style={{ width: "35%" }}
            >
              <span className="ft-10" style={{ width: "35%" }}>
                <AddToolTip
                  name={
                    !isNull(fieldName)
                      ? `${fieldName} ${
                          values[fields.fieldName]
                            ? `| ${values[fields.fieldName]}`
                            : ""
                        }`
                      : fieldName
                  }
                />
              </span>
              <span className="d-flex ft-10" style={{ width: "30%" }}>
                <span className="grey-text mr-1">Value:</span>
                <AddToolTip
                  name={
                    get(values, "valueData.parameterType") == 1
                      ? get(values, "valueData.value.value")
                      : get(values, "valueData.parameterType") == 3
                      ? get(values, "valueData.value")
                      : stringToFunctionConverter(
                          jsonToStringConverter(values?.valueData),
                          0
                        )
                  }
                />
              </span>
              <span className="d-flex ft-10 " style={{ width: "15%" }}>
                <span className="grey-text mr-1">From:</span>
                <span className="black-text">{values[fields.from]}</span>
              </span>
              <span className="d-flex ft-10" style={{ width: "15%" }}>
                <span className="grey-text mr-1">To:</span>
                <span className="black-text">{values[fields.to]}</span>
              </span>
              <div style={{ height: "25px" }}>
                <div className="flag">
                  <p id="flagTextForViewMore">
                    {values[fields.typeSetting] == 1
                      ? "key"
                      : values[fields.typeSetting] == 2
                      ? "Generic"
                      : "Indicator"}
                  </p>
                </div>
              </div>
            </div>
          )}
          <span
            className={`ft-12 link-text-mapper cursor-pointer ${
              !isFixedWidth ? "ml-3" : "ml-2"
            }`}
            onClick={() => setShow(!show)}
          >
            View more
          </span>
        </div>
      ) : (
        <div className="preview-container">
          <div
            className="d-flex justify-content-between mb-2"
            style={{ width: "47%" }}
          >
            <span className="ft-14 fw-500">
              Preview<span class="active-dot">●</span>
            </span>
            <span
              className="ft-12 link-text-mapper cursor-pointer"
              onClick={() => setShow(!show)}
            >
              View less
            </span>
          </div>

          <div className="d-flex preview-card pb-0" style={{ width: "47%" }}>
            <div className="mt-4" style={{ width: "13%" }}>
              <span className="ft-12 fw-500">
                {mapType == 3 ? (
                  isNewField ? (
                    <AddToolTip
                      name={passthroughStringToFunctionConverter(
                        jsonToStringConverter(values?.headerData),
                        sourceData?.fields,
                        0
                      )?.toString()}
                    />
                  ) : (
                    <AddToolTip name={values.headerData.value} />
                  )
                ) : get(values, "headerData.parameterType") ? (
                  <AddToolTip
                    name={stringToFunctionConverter(
                      jsonToStringConverter(values?.headerData),
                      1
                    )?.toString()}
                  />
                ) : (
                  <AddToolTip name={`${values[fields.fieldName]}`} />
                )}
              </span>
              <span className="d-flex ft-10 mt-1">
                <span className="grey-text mr-1">Value:</span>
                <AddToolTip
                  className={"ml-1"}
                  style={{ marginTop: "3px" }}
                  name={
                    mapType == 3
                      ? passthroughStringToFunctionConverter(
                          jsonToStringConverter(values?.valueData),
                          sourceData?.fields,
                          1
                        )?.toString()
                      : stringToFunctionConverter(
                          jsonToStringConverter(values?.valueData),
                          0
                        )?.toString()
                  }
                />
              </span>
            </div>

            {isFixedWidth && (
              <span
                className="ft-10"
                style={{
                  width: "5%",
                  marginTop: "25px",
                  marginRight: "10px",
                  marginLeft: "10px",
                }}
              >
                <p className="grey-text mr-1 mb-0">From</p>
                <p className="black-text mt-0">{values[fields.from]}</p>
              </span>
            )}
            {isFixedWidth && (
              <span
                className="ft-10"
                style={{
                  width: "5%",
                  marginTop: "25px",
                  marginRight: "10px",
                  marginLeft: "10px",
                }}
              >
                <p className="grey-text mr-1 mb-0">To</p>
                <p className="black-text mt-0">{values[fields.to]}</p>
              </span>
            )}

            {isFixedWidth && (
              <div className="flagFixedWidth">
                <p id="flagText">
                  {" "}
                  {values[fields.typeSetting] == 1
                    ? "key"
                    : values[fields.typeSetting] == 2
                    ? "Generic"
                    : "Indicator"}
                </p>
              </div>
            )}

            <div className="vertical-line" />
            <div className="w-75">
              <div className="mb-2">
                <div className="ft-12 fw-500">Header Expression</div>
                <p className="ft-10">
                  {mapType == 3 ? (
                    isNewField ? (
                      <AddToolTip
                        name={jsonToStringConverter(values?.headerData)}
                      />
                    ) : (
                      <AddToolTip name={values.headerData.value} />
                    )
                  ) : get(values, "headerData.parameterType") ? (
                    <AddToolTip
                      name={jsonToStringConverter(values?.headerData)}
                    />
                  ) : (
                    <AddToolTip name={`${values[fields.fieldName]}`} />
                  )}
                </p>
              </div>
              <div>
                <div className="ft-12 fw-500">Value Expression</div>
                <div className="ft-10 mb-2 w-70">
                  <AddToolTip name={jsonToStringConverter(values?.valueData)} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewSection;
